import { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar({ onOpenModal }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavLink = (e, id) => {
    e.preventDefault();
    const target = document.querySelector(id);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={scrolled ? 'scrolled' : ''}>
      <a href="#" className="nav-logo">
        <img src="/Impact-your-wealth-Logo_.png.webp" alt="Impact Your Wealth" style={{ height: '70px', width: 'auto', display: 'block' }} />
      </a>

      <ul>
        <li><a href="#expertise" onClick={(e) => handleNavLink(e, '#expertise')}>Our Services</a></li>
        <li><a href="#about"     onClick={(e) => handleNavLink(e, '#about')}>About Dr. Patel</a></li>
        <li><a href="#reviews"   onClick={(e) => handleNavLink(e, '#reviews')}>Clients</a></li>
        <li><a href="#contact"   onClick={(e) => handleNavLink(e, '#contact')}>Contact</a></li>
      </ul>

      <a href="#" className="nav-btn" onClick={(e) => { e.preventDefault(); onOpenModal(); }}>
        Free Consultation
      </a>
    </nav>
  );
}

export default Navbar;
